import { Textarea as NulogyTextarea } from "@nulogy/components";
import { useField, useFormikContext } from "formik";
import React from "react";

export default function Textarea({ field: name, onChange, ...ndsProps }) {
  const { setFieldValue } = useFormikContext();
  const [field, meta, helpers] = useField(name);

  const handleChange = (event) => {
    const { value } = event.target;

    if (onChange) {
      onChange({ setFieldValue, value });
    }
    helpers.setValue(value);
  };

  return (
    <NulogyTextarea errorMessage={meta.error} name={name} onChange={handleChange} value={field.value} {...ndsProps} />
  );
}
